import { all, put, call, takeLatest } from 'redux-saga/effects'
import axios from 'portal/utils/axios-msal'

import {
  projectDocumentTokenLoadSuccess,
  projectDocumentTokenLoadFailure,
  PROJECT_DOCUMENTS_TOKEN_LOAD,
  ProjectDocumentTokenLoadAction
} from './actions'

function* projectDocumentTokenLoadSaga(action: ProjectDocumentTokenLoadAction) {
  const { accountId, projectId } = action

  try {
    const response: { data: string } = yield call(() =>
      axios.get(
        `/accounts/${accountId}/projects/${projectId}/documentstoken`,
        {}
      )
    )

    const projectDocumentToken: string =
      response && response.data ? response.data : ''

    yield put(
      projectDocumentTokenLoadSuccess(
        accountId,
        projectId,
        projectDocumentToken
      )
    )
  } catch (error) {
    console.error(error)
    yield put(projectDocumentTokenLoadFailure(accountId, projectId, error))
  }
}

export function* watch() {
  yield all([
    takeLatest(PROJECT_DOCUMENTS_TOKEN_LOAD, projectDocumentTokenLoadSaga)
  ])
}
